var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.translates_loaded)?_c('div',{staticClass:"wrap"},[_c('top-header'),_c('i-header'),_c('router-view',{staticClass:"router-view",attrs:{"id":"main-view"}}),_c('sub-footer'),_c('i-footer'),_c('back-to-top'),_c('i-image-viewer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }